import { UswfGoogleMap } from './UswfGoogleMap';
import { UswfAddressAutoComplete } from './UswfAddressAutoComplete';
import React from 'react';

export const AddressSelector = ({
  isGoogleApiLoaded,
  showMap,
  center,
  mapHeight,
  onGoogleMapLoad,
  onGoogleMapUnmount,
  placesService,
  googleMap,
  setState,
  setAddress,
}) => (
  <>
    <UswfGoogleMap
      isGoogleApiLoaded={isGoogleApiLoaded}
      showMap={showMap}
      center={center}
      mapHeight={mapHeight}
      onGoogleMapLoad={onGoogleMapLoad}
      onGoogleMapUnmount={onGoogleMapUnmount}
    />
    <div className="autocomplete-wrapper">
      <UswfAddressAutoComplete
        placesService={placesService}
        isGoogleApiLoaded={isGoogleApiLoaded}
        googleMap={googleMap}
        setState={setState}
        setAddress={setAddress}
      />
    </div>
  </>
)
